import { useCallback, useState } from 'react';
import styled, { css } from 'foundations-theming/utils';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { Image } from 'foundations-components/transitional/components/Image';
import { useBreakpoint } from 'portals-platform-lib';
import LogoUploadModal from './LogoUploadModal';
import { LogoPlaceholder } from '../styledComponents/LogoPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EditIconOverlay = styled.div.withConfig({
  displayName: "BuyerBrandLogo__EditIconOverlay"
})(["", ""], ({
  theme
}) => {
  return css(["position:absolute;top:-4px;right:-4px;opacity:0;transition:opacity 150ms ease;display:flex;align-items:center;justify-content:center;width:", ";height:", ";border-radius:", ";background-color:", ";border-width:", ";border-color:", ";border-style:solid;box-shadow:", ";"], theme.space['500'], theme.space['500'], theme.borderRadius['full'], theme.color['fill-surface-default'], theme.borderWidth['100'], theme.color['border-core-default'], theme.boxShadow['100']);
});
const StyledLogoButton = styled.button.withConfig({
  displayName: "BuyerBrandLogo__StyledLogoButton"
})(["position:relative;cursor:pointer;border:none;background:none;padding:0;:hover ", ",:focus-visible ", "{opacity:1;}"], EditIconOverlay, EditIconOverlay);
export default function BuyerBrandLogo({
  src,
  isHubSpotUser,
  dealPlanId
}) {
  const isMobile = useBreakpoint() === 'mobile';
  const [uploadedSrc, setUploadedSrc] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleUploadLogo = useCallback(url => {
    setUploadedSrc(url);
    setIsModalOpen(false);
  }, []);
  const handleCloseModal = useCallback(() => setIsModalOpen(false), []);
  const buyerLogoSrc = uploadedSrc !== null && uploadedSrc !== void 0 ? uploadedSrc : src;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledLogoButton, {
      "aria-label": "Edit buyer logo",
      onClick: () => setIsModalOpen(true),
      disabled: !isHubSpotUser,
      children: [buyerLogoSrc ? /*#__PURE__*/_jsx(Image, {
        src: buyerLogoSrc,
        "data-test-id": "buyer-logo-image",
        maxBlockSize: isMobile ? '32px' : '44px',
        maxInlineSize: isMobile ? '120px' : '150px'
      }) : /*#__PURE__*/_jsx(LogoPlaceholder, {
        "data-test-id": "buyer-logo-placeholder",
        isMobile: isMobile
      }), isHubSpotUser && /*#__PURE__*/_jsx(EditIconOverlay, {
        children: /*#__PURE__*/_jsx(EditIcon, {
          size: "100",
          color: "text-primary-disabled"
        })
      })]
    }), isModalOpen && /*#__PURE__*/_jsx(LogoUploadModal, {
      dealPlanId: dealPlanId,
      onUpload: handleUploadLogo,
      onClose: handleCloseModal
    })]
  });
}